import { FAQ, faqData } from './faqData.js';
import './App.css';
import { useState, useEffect, useRef} from 'react'
import userAvatar from './img/user.png';
import chatAvatar from './img/logo.png';
function App() {
  const [input, setInput] = useState("");
  const [chatLog, setChatLog] = useState([]);
  const endOfMessagesRef = useRef(null);

  const scrollToBottom = () => {
    endOfMessagesRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    scrollToBottom();  // Scroll to bottom whenever chatLog changes
  }, [chatLog]);
  // const clearChat = () => {
  //   setChatLog([]);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let messageToSend;
    if (typeof e === "string") {
      messageToSend = e;
    } else {
      messageToSend = input;
    }
    
    let chatLogNew = [...chatLog, { user: "me", message: messageToSend }];
    setInput("");
    setChatLog(chatLogNew);

    const response = await fetch("https://chat-bot-ai-server-puce.vercel.app/", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({ message: messageToSend })
    });
    const data = await response.json();
    setChatLog([...chatLogNew, { user: "gpt", message: data.message }]);
  };

  const handleFAQQuestionClick = (question) => {
    const faqAnswer = faqData[question];
    setChatLog(chatLog => [...chatLog, { user: "me", message: question }]);
    if (faqAnswer) {
      setChatLog(chatLog => [...chatLog, { user: "FAQ", message: faqAnswer }]);
    } else {
      handleSubmit(question);
    }
  };
  return (
    <div className="App">
      <div className='modal'>
        
          {/* <div className='new-chat-div'><div onClick={clearChat} className='new-chat'>Vymazat</div></div> */}
          <div className='faq-div'><FAQ onQuestionClick={handleFAQQuestionClick} /></div>
          <div className='main-div-message'>
            <div className='message'>{chatLog.map((message, index) => (
              <ChatMessage key={index} message={message} className={message.user}/>
            ))}
            <div ref={endOfMessagesRef} />
            </div>
        </div>
          <div className='input-div'>
            <form onSubmit={handleSubmit}>
              <input 
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Napište Vaš dotaz"
                className='input'
              />
              <button type="submit" onClick={handleSubmit} className="submit-button"></button>
            </form>
          </div>
        </div>
    </div>
  );
}
const makeLinksClickable = (message) => {
  const regex = /(https?:\/\/[^\s]+[^\s.,;()])/g;
  return message.replace(regex, (url) => {
    return `<a href="${url}" target="_blank" style="color: #56c1a8;">${url}</a>`;
  });
};
const getAvatar = (user) => {
  if (user === "me") {
    return userAvatar;
  } else if (user === "gpt") {
    return chatAvatar;
  } else if (user === "FAQ") {
    return chatAvatar;
  }
};
const ChatMessage = ({ message, className }) => {
  let messageContent = message.message;
  let avatar = getAvatar(message.user);

  
  if (Array.isArray(messageContent)) {
    messageContent = messageContent[0]?.text?.value || "Omlouvám se, došlo k chybě. Přeformulujte prosím otázku";
  }

  messageContent = makeLinksClickable(messageContent);

  return (
    <div className={`message-container ${className}`}>
      <div className="avatar-container">
        <img src={avatar} alt={`${message.user} avatar`} className="avatar" />
      </div>
      <div className={`bublinka ${className}`}>
        <p className='text-p' dangerouslySetInnerHTML={{ __html: messageContent }} />
      </div>
    </div>
  );
};

export default App;

